// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
import moment from 'moment'
// @end

// @import components
import {NewsModuleLayout} from 'app_components/modules/campus/news'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import PostService from 'app_services/campus/postService'
// @end

// @import types
// @end

// @ADD Component types
interface INewsModuleProps {
  category: 'student' | 'teacher' | 'account_executive' | 'company'
}
interface INewsModuleState {
  posts: Array<any>
  status: null | 'loading' | 'error'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class NewsModule extends Component<INewsModuleProps, INewsModuleState> {

  private nPerPage = 3;
  private postService: PostService;

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: INewsModuleProps) {
    super(props)
    this.state = {
      posts: [],
      status: 'loading',
    }
    this.postService = new PostService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.getList()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  getList = async (params?: any) => {
    this.setState({ status: 'loading' })

    let httpParams: any = {
      pageNumber: 1,
      nPerPage: this.nPerPage,
      isActive: true,
      postType: ['news'],
      postDate: {
        date: 'today',
        direction: 'lte'
      },
      locations: [this.props.category],
      sort: {
        field: 'postDate',
        direction: -1
      }
    }

    let posts: Array<any> = []

    const postsResponse = await this.postService.fetchPosts(httpParams)

    if (postsResponse && postsResponse.posts) {
      posts = postsResponse.posts.reduce((accum: any, element: any) => {
        let postDate = moment.utc(element?.postDate)
        let item = {
          key: element?._id,
          slug: element?.slug,
          cover: element?.coverUrl,
          postDate: postDate.format('DD/MM/YYYY'),
          title: element?.title,
          subtitle: element?.subtitle
        }

        accum.push(item)

        return accum
      }, [])
    }

    this.setState({
      posts,
      status: null
    })
  }

  render() {
    return(
      <NewsModuleLayout
        {...this.props}
        posts={this.state.posts}
        status={this.state.status}
      />
    )
  }
}

export default connect(mapStatesToProps)(NewsModule)
